const openModal = (modal) => {
  modal.classList.add('is-open')
  modal.setAttribute('aria-hidden', 'false')
  document.body.style.overflow = 'hidden'
}

const closeModal = (modal) => {
  modal.classList.remove('is-open')
  modal.setAttribute('aria-hidden', 'true')
  document.body.style.overflow = ''
}

const initFiltersModal = () => {
  const modal = document.getElementById('occasions-filters-modal')
  if (!modal) return

  document.querySelectorAll('[data-modal-open="occasions-filters-modal"]').forEach(btn => {
    btn.addEventListener('click', () => openModal(modal))
  })

  document.querySelectorAll('[data-modal-close="occasions-filters-modal"]').forEach(btn => {
    btn.addEventListener('click', () => closeModal(modal))
  })

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal(modal)
    }
  })
}

const initSortDropdown = () => {
  document.querySelectorAll('[data-sort-dropdown]').forEach(dropdown => {
    const trigger = dropdown.querySelector('.occasions-list__sort-dropdown-trigger')
    const list = dropdown.querySelector('.occasions-list__sort-dropdown-list')
    const valueEl = dropdown.querySelector('.occasions-list__sort-dropdown-value')
    const nativeSelect = dropdown.querySelector('select')
    if (!trigger || !list) return

    const open = () => {
      list.classList.add('is-open')
      trigger.setAttribute('aria-expanded', 'true')
    }
    const close = () => {
      list.classList.remove('is-open')
      trigger.setAttribute('aria-expanded', 'false')
    }

    trigger.addEventListener('click', () => {
      list.classList.contains('is-open') ? close() : open()
    })

    list.querySelectorAll('.occasions-list__sort-dropdown-option').forEach(option => {
      option.addEventListener('click', () => {
        list.querySelectorAll('.occasions-list__sort-dropdown-option').forEach(o => {
          o.classList.remove('is-selected')
          o.setAttribute('aria-selected', 'false')
        })
        option.classList.add('is-selected')
        option.setAttribute('aria-selected', 'true')
        valueEl.textContent = option.textContent.trim()
        if (nativeSelect) nativeSelect.value = option.dataset.value
        close()
        document.dispatchEvent(new CustomEvent('occasions:sort-change', { detail: { value: option.dataset.value } }))
      })
    })

    document.addEventListener('click', e => {
      if (!dropdown.contains(e.target)) close()
    })
  })
}

const initSeeMore = () => {
  document.querySelectorAll('.occasions-filters__see-more').forEach(btn => {
    const list = btn.closest('fieldset').querySelector('.occasions-filters__checkbox-list--collapsed')
    if (!list) return
    btn.addEventListener('click', () => {
      list.classList.remove('occasions-filters__checkbox-list--collapsed')
      btn.hidden = true
    })
  })
}

// Recherche dans la liste de localisations : filtre les checkboxes selon la saisie.
const initLocationSearch = () => {
  // Insensible à la casse et aux accents (ex. "esp" → "Espagne"/"España").
  const normalize = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim()

  document.querySelectorAll('.occasions-filters__location-input').forEach(input => {
    const fieldset = input.closest('fieldset')
    if (!fieldset) return
    const list = fieldset.querySelector('.occasions-filters__checkbox-list')
    if (!list) return
    const items = Array.from(list.querySelectorAll('.occasions-filters__checkbox-item'))
    const seeMore = fieldset.querySelector('.occasions-filters__see-more')

    // Évite un submit/reload du formulaire si l'utilisateur appuie sur Entrée.
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') e.preventDefault()
    })

    input.addEventListener('input', () => {
      const query = normalize(input.value)

      // Champ vidé : on retire les styles inline → le CSS reprend la main
      // (le collapse et le bouton "voir plus" retrouvent leur état d'origine).
      if (!query) {
        items.forEach(item => { item.style.display = '' })
        if (seeMore) seeMore.hidden = !list.classList.contains('occasions-filters__checkbox-list--collapsed')
        return
      }

      // Recherche active : le JS pilote la visibilité. `display: flex` explicite
      // (inline) surcharge la règle nth-child du collapse pour ne rien masquer.
      items.forEach(item => {
        const textEl = item.querySelector('.occasions-filters__checkbox-text')
        const text = textEl ? normalize(textEl.textContent) : ''
        item.style.display = text.includes(query) ? 'flex' : 'none'
      })
      if (seeMore) seeMore.hidden = true
    })
  })
}

// Localisation : les checkboxes cochées remontent en haut de la liste.
const initLocationSort = () => {
  document.querySelectorAll('.occasions-filters__location-search').forEach(search => {
    const fieldset = search.closest('fieldset')
    if (!fieldset) return
    const list = fieldset.querySelector('.occasions-filters__checkbox-list')
    if (!list) return
    const items = Array.from(list.querySelectorAll('.occasions-filters__checkbox-item'))
    if (!items.length) return

    // Ordre d'origine (items non cochés) + compteur de récence (la dernière cochée
    // passe tout en haut).
    items.forEach((item, i) => { item.dataset.originalOrder = String(i) })
    let checkSeq = 0

    const reorder = () => {
      const sorted = items.slice().sort((a, b) => {
        const ia = a.querySelector('.occasions-filters__checkbox-input')
        const ib = b.querySelector('.occasions-filters__checkbox-input')
        if (ia.checked !== ib.checked) return ia.checked ? -1 : 1
        // Deux cochées : la plus récemment cochée en premier.
        if (ia.checked) return Number(b.dataset.checkOrder) - Number(a.dataset.checkOrder)
        // Deux non cochées : ordre d'origine.
        return Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder)
      })
      // appendChild déplace les nœuds existants → l'ordre final suit `sorted`.
      sorted.forEach(item => list.appendChild(item))
    }

    list.addEventListener('change', (e) => {
      const input = e.target
      if (!input.matches('.occasions-filters__checkbox-input')) return
      if (input.checked) {
        input.closest('.occasions-filters__checkbox-item').dataset.checkOrder = String(++checkSeq)
      }
      reorder()
    })
  })
}

const initGarantieModal = () => {
  const modal = document.getElementById('occasions-garantie-modal')
  if (!modal) return

  document.querySelectorAll('[data-garantie-modal-open]').forEach(btn => {
    btn.addEventListener('click', () => openModal(modal))
  })

  document.querySelectorAll('[data-garantie-modal-close]').forEach(el => {
    el.addEventListener('click', () => closeModal(modal))
  })

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal(modal)
    }
  })
}

if (document.readyState !== 'loading') {
  initFiltersModal()
  initGarantieModal()
  initSeeMore()
  initLocationSearch()
  initLocationSort()
  initSortDropdown()
} else {
  document.addEventListener('DOMContentLoaded', () => {
    initFiltersModal()
    initGarantieModal()
    initSeeMore()
    initLocationSearch()
    initLocationSort()
    initSortDropdown()
  })
}
